import { render, staticRenderFns } from "./GroupReports.vue?vue&type=template&id=bfd32bfa&lang=html"
import script from "./GroupReports.vue?vue&type=script&lang=js"
export * from "./GroupReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports